window.onerror = function(msg, url, line, col, error) {
  var extra = !col ? '' : '\ncolumn: ' + col;
  extra += !error ? '' : '\nerror: ' + error;

  errorReportUrl = '/handle/web/error'


  values = {'msg' : msg, 'url' : url, 'line' : line, 'extra' : extra, 'user' : window.state.user}
  options = values => ({
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  })

  fetch(errorReportUrl, options(values))

};
